import { motion } from "framer-motion";
import styled from "styled-components";

const ShowError = ({ message }) => {
  return (
    <Wrapper>
      <Circle />
      <Message>{message}</Message>
    </Wrapper>
  );
};

export const ShowSuccess = ({ message }) => {
  return (
    <Wrapper animate={{ y: 0, opacity: 1 }} initial={{ y: -20, opacity: 0 }}>
      <Circle style={{ background: "#26CC83" }} />
      <Message style={{ color: "#2ba872" }}>{message}</Message>
    </Wrapper>
  );
};

const Wrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  margin: 5px 0;
`;

const Circle = styled.div`
  width: 8px;
  height: 8px;
  background: #cc2626;
  border-radius: 50%;
  margin-left: 10px;
`;

const Message = styled.div`
  font-size: 12px;
  font-weight: 300;
  color: #cc2626;
`;

export default ShowError;
